<template>
    <div class="bg" :style="{ 'background-image': 'url(' + certificateDetail.configurationVO.bgBigImg + ')' }">
        <!-- <img v-if="certificateDetail.eventName.includes('RAM')" class="bg" src="../assets/img/ramBg.png" alt="">
        <img v-else-if="certificateDetail.eventName.includes('SuperBridge')" class="bg" src="../assets/img/reportbj.png" alt=""> -->
        <!-- <img v-else class="bg" src="../assets/img/certificateTemplatebj.png" alt=""> -->
        <!-- <img class="bg" :src="certificateDetail.configurationVO.bgBigImg" alt=""> -->
        <div class="wrap">
            <div class="imgs">
                <!-- <img v-if="certificateDetail.eventName.includes('RAM')" class="logo" src="../assets/img/ramLogo.png" alt="">
                <img v-else-if="certificateDetail.eventName.includes('SuperBridge')" class="logo" src="../assets/img/reportlogo.png" alt="">
                <img v-else class="logo" src="../assets/img/certificateTemplateLogo.png" alt=""> -->
                <img class="logo" :src="certificateDetail.configurationVO.logoImageUrl" alt="">
            </div>
            <div class="title">{{ $t('CARBONNEUTRALITYCERTIFICATE') }}</div>
            <div class="con">
                <!-- This is to certify that &lt;&lt; {{certificateDetail.name}}&gt;&gt; is 
                <span>carbon neutral</span>
                for the event specified above. -->
                {{ $t('Thisistocertifythat') }} {{ certificateDetail.name ? certificateDetail.name : '--' }} {{ $t('hasneutralized') }}
                {{ certificateDetail.carbonPercentage ? certificateDetail.carbonPercentage : '--' }}% {{ $t('oftheirCarbonFootprint') }}
                 <!-- <span v-if="certificateDetail.eventName">{{ $t('forthe') }} {{ certificateDetail.eventName ?
                    certificateDetail.eventName : '--'}}</span>. -->
                <!-- This is to certify that {{certificateDetail.name}} has neutralised {{certificateDetail.carbonPercentage}}% of Carbon Footprint for {{certificateDetail.operationName}} -->
            </div>
            <ul class="table">
                <li class="item">
                    <div>{{ $t('CERTIFICATENO') }}:</div>
                    <div>{{ certificateDetail.giftCardInfo.certificateNo ? certificateDetail.giftCardInfo.certificateNo :
                        '--'}}</div>
                </li>
                <!-- <li class="item">
                    <div>ISSUER:</div>
                    <div>METAVERSE GREEN EXCHANGE PTE LTD</div>
                </li> -->
                <li class="item" v-if="certificateDetail.eventName">
                    <div>{{ $t('CARBONNEUTRALITYEVENT') }}:</div>
                    <div>{{ certificateDetail.eventName ? certificateDetail.eventName : '--' }} </div>
                </li>
                <li class="item">
                    <div>{{ $t('CARBONFOOTPRINTDECLARED') }}:</div>
                    <div>{{ certificateDetail.neutralizeAmount ? certificateDetail.neutralizeAmount : '--' }} kg of CO₂
                        {{ $t('equivalent') }}</div>
                </li>
                <li class="item">
                    <div>{{ $t('CARBONCREDITSRETIRED') }}:</div>
                    <div>{{ certificateDetail.neutralizeAmount ? certificateDetail.neutralizeAmount : '--' }} kg of CO₂
                        {{ $t('equivalent') }} ({{ certificateDetail.neutralizeAmountTong ? certificateDetail.neutralizeAmountTong :
                        '--'}} {{ $t('CarbonNeutralityTokensburnt') }})</div>
                </li>
                <li class="item">
                    <div>{{ $t('DATEOFCARBONNEUTRALITYTOKENSBURNT') }}:</div>
                    <div v-if="$i18n.locale == 'en'">{{ certificateDetail.burntDate ? formatDateDay(certificateDetail.burntDate) : '--' }}</div>
                    <div v-else>{{ certificateDetail.burntDate ? formatDatey(certificateDetail.burntDate) : '--' }}</div>
                </li>
                <li class="item">
                    <div>{{ $t('NAME') }}:</div>
                    <div>{{ certificateDetail.name }}</div>
                </li>
                <li class="item">
                    <div>{{ $t('CERTIFICATIONTEXT') }}:</div>
                    <div v-if="$i18n.locale == 'en'">{{ $t('Thisistocertifythat') }} {{ certificateDetail.name }} {{ $t('hasneutralised') }}
                        {{ certificateDetail.carbonPercentage }}% {{ $t('oftheirCarbonFootprintforthe') }}
                        {{ certificateDetail.operationName }} {{ $t('event') }}</div>
                    <div v-else>兹证明{{ certificateDetail.name }}已对本次{{ certificateDetail.operationName }}活动产生的碳足迹实现了({{ certificateDetail.carbonPercentage }}%)中和</div>
                </li>
                <li class="item">
                    <div>{{ $t('CARBONNEUTRALISATIONTRANSACTIONID') }}:</div>
                    <div>{{ certificateDetail.transactionId ? certificateDetail.transactionId : '--' }}</div>
                </li>
            </ul>

            <div class="date">
                <div>{{ $t('MetaVerseGreenExchange') }}</div>
                <div v-if="$i18n.locale == 'en'">{{ certificateDetail.burntDate ? formatDateDay(certificateDetail.burntDate) : '--' }}</div>
                <div v-else>{{ certificateDetail.burntDate ? formatDatey(certificateDetail.burntDate) : '--' }}</div>

            </div>
        </div>
    </div>
</template>

<script>
import cnt from '@/api/cnt'
import { formatDatey, formatDateDay } from '@/util/date'
export default {
    data() {
        return {
            sn: '',
            certificateDetail: {},
            userinfo: '',
        }
    },
    mounted() {
        console.log('jinru')
        // this.userinfo = JSON.parse(sessionStorage.getItem('activityInfo'))
        this.sn = this.$route.query.sn
        this.getTravelRecord()
        // this.getUserEvent(1,1)
    },
    methods: {
        formatDatey: formatDatey,
        formatDateDay: formatDateDay,
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        getTravelRecord() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            cnt.getuserInfo(res => {
                console.log('res', res)
                this.certificateDetail = res.data
            }, { sn: this.sn })
        }
    }
}
</script>
<style lang='less' scoped>
// .bg{
//     display: block;
//     width: 100%;
//     height: 100%;
//     position: relative;
// }
.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.wrap {
    position: absolute;
    top: 0;
    left: 0;
}

.imgs {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10.3125rem 0 3.8125rem;
}

.logo {
    width: 12.875rem;
    height: 8.5625rem;

}

.title {
    margin: 0 11.4375rem;
    font-size: 1.875rem;
    font-family: Gotham-Bold, Gotham;
    font-weight: bold;
    color: #134475;
    text-align: center;
}

.table {
    margin: 2.1875rem 3.75rem 1.875rem 3.9375rem;
    border: .0625rem solid #FFFFFF;
}

li {
    list-style: none;
}

.item {
    border-bottom: .0625rem solid #FFFFFF;
    display: flex;
    font-weight: bold;
}

.item {
    div {
        width: 50%;
        font-size: .6875rem;
        font-family: Gotham-Book, Gotham;
        color: #1E1E1E;
        padding: .5rem 1.25rem .625rem;
        display: flex;
        align-items: center;
    }

    div:first-child {
        border-right: .0625rem solid #BFBFBF;
    }

    :last-child {
        white-space: normal;
        word-break: break-word;
    }


}

.item:last-child {
    border: none;
}

.con {
    font-size: .9375rem;
    font-family: Gotham-Book, Gotham;
    color: #1E1E1E;
    margin: 3.1875rem 8.9375rem 4.1875rem 9.125rem;
    text-align: center;
}

.con {
    span {
        font-weight: bold;
    }
}

.date {
    font-size: .6875rem;
    font-family: Gotham-Book, Gotham;
    font-weight: normal;
    color: #000000;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    text-align: right;
    margin: 0 3.75rem;
}
</style>